import React from 'react'
import PropTypes from 'prop-types'
import { Alert, AlertTitle, Box, Button, Stack, Typography } from '@mui/material'

class AppErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError (error) {
    return { error }
  }

  componentDidCatch (error, errorInfo) {
    console.error('Unhandled Highlights UI error', error, errorInfo)
  }

  render () {
    const { error } = this.state

    if (!error) {
      return this.props.children
    }

    return (
      <Box sx={{ maxWidth: 760, mx: 'auto', p: { xs: 2, sm: 4 } }}>
        <Alert severity="error">
          <AlertTitle>Something went wrong in the application</AlertTitle>
          <Stack spacing={2}>
            <Typography variant="body2">
              The rest of the site is still available. Reload this page to retry, and if the
              problem continues the browser console will contain the original error.
            </Typography>
            <Typography
              component="pre"
              variant="caption"
              sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', m: 0 }}
            >
              {error.message}
            </Typography>
            <Box>
              <Button variant="contained" onClick={() => window.location.reload()}>
                Reload page
              </Button>
            </Box>
          </Stack>
        </Alert>
      </Box>
    )
  }
}

AppErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
}

export default AppErrorBoundary
